// Compatibility shim: the project no longer uses TanStack Start server functions.
// Data access happens directly from the browser through the Supabase client, so
// "server functions" are plain async functions and this hook is the identity.
export function useServerFn<T extends (...args: any[]) => any>(fn: T): T {
  return fn;
}
